import React, { useEffect, useRef, useState } from 'react';

/**
 * Fades and slides content in when it enters the viewport (scroll-triggered reveal).
 */
export function FadeInOnScroll({
  children,
  className = '',
  rootMargin = '0px 0px -48px 0px',
  threshold = 0.06,
  once = true,
}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return;
    }
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setVisible(true);
          if (once) io.disconnect();
        }
      },
      { root: null, rootMargin, threshold },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [once, rootMargin, threshold]);

  return (
    <div
      ref={ref}
      className={`
        transition-all duration-500 ease-out motion-reduce:transition-none
        ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}
        ${className}
      `}
    >
      {children}
    </div>
  );
}
